import { useEffect, useMemo } from "react";

import { useQuery } from "@apollo/client";

import type {
  GetLocationsQuery,
  GetLocationsQueryVariables,
  PaginatedLocations,
} from "../../API";
import { GET_LOCATIONS } from "../operations/queries";
import { useCustomerIdGuard } from "./useCustomerIdGuard";

export const useGetLocations = () => {
  const selectedCustomerId = useCustomerIdGuard();

  useEffect(() => {
    if (selectedCustomerId) {
      refetch({ customerId: selectedCustomerId });
    }
  }, [selectedCustomerId]);

  const { data, loading, refetch } = useQuery<
    GetLocationsQuery,
    GetLocationsQueryVariables
  >(GET_LOCATIONS, { variables: { customerId: selectedCustomerId } });

  const locations = useMemo(
    () => data?.getLocations as PaginatedLocations,
    [data?.getLocations]
  );

  return { locations, loading } as const;
};
